//
//
//
//
//
//
//

import vFooter from '@/components/com-footer.vue';
export default {
    components: {
        vFooter,
       
    },
    data () {
        return {
            
        }
    },
    methods: {
    },
}



// WEBPACK FOOTER //
// ./src/views/PagesView.vue